﻿import Modal from '../../../vendor/bootstrap/js/dist/modal.js';
import Carousel from '../../../vendor/bootstrap/js/dist/carousel.js';
import ajaxPartials from './ajax-partials.js';

export default function imageGallery(modal) {

    const displayCarousel = function () {
        modal.querySelector('.modal-body .carousel').classList.remove('d-none');
    };

    const init = function () {

        // Get all image gallery modals and listen to the show event
        modal.addEventListener('show.bs.modal', evt => {

            var trigger = evt.relatedTarget;
            if (!trigger)
                return;

            var modalBody = modal.querySelector('div.modal-body');

            var folderId = parseInt(trigger.getAttribute('data-folderid'));
            if (isNaN(folderId)) {
                
                const img = document.createElement('img');
                img.setAttribute('src', trigger.getAttribute("href"));

                modalBody.innerHTML = '';
                modalBody.appendChild(img);

                return;
            }

            // Load entire gallery
            var recursive = trigger.getAttribute('data-recursive');

            
            modalBody.setAttribute('data-ajax-url', '/umbraco/Furillo/EditorsApi/GetImageGalleryCarousel?folderId=' + folderId + '&recursive=' + recursive);
            
            // Use ajax partials to make the request for the carousel
            ajaxPartials.makeRequest(modal.querySelector('div[data-ajax-url]'), function () {

                // After fetching carousel, initiate it
                const carousel = Carousel.getOrCreateInstance(modal.querySelector('.modal-body .carousel'));

                // Try to send the user to correct slide
                const imageId = parseInt(trigger.getAttribute('data-imageid'));
                if (isNaN(imageId) || imageId === 0) {
                    displayCarousel();
                    return;
                }


                const items = modal.querySelectorAll('.modal-body .carousel .carousel-item');
                if (!items || items.length === 0) {
                    displayCarousel();
                    return;
                }

                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (parseInt(item.getAttribute('data-imageid')) !== imageId)
                        continue;

                    carousel.to(i);
                    displayCarousel();
                    break;
                }
            });
        });
    };

    init();
}



//export default function imageGallery(elements) {

//    const displayCarousel = function(modal) {
//        modal.querySelector('.modal-body .carousel').classList.remove('d-none');
//    };

//    const init = function(element) {

//        // Get all image gallery modals and listen to the show event
//        var modal = element.querySelector('div.modal.modal-imagegallery');
//        modal.addEventListener('show.bs.modal', evt => {

//            //data-ajax-url="@($"/umbraco/Furillo/EditorsApi/GetImageGalleryCarousel?folderId={Model.value.folderId}&recursive={Model.value.recursive}")" data-ajax-autoload="false"

//            // Use ajax partials to make the request for the carousel
//            ajaxPartials.makeRequest(modal.querySelector('div[data-ajax-url]'), function () {

//                // After fetching carousel, initiate it
//                const modal = evt.target;
//                const carousel = Carousel.getOrCreateInstance(modal.querySelector('.modal-body .carousel'));

//                // Try to send the user to correct slide
//                const imageId = !evt.relatedTarget ? 0 : parseInt(evt.relatedTarget.getAttribute('data-imageid'));
//                if (isNaN(imageId) || imageId === 0) {
//                    displayCarousel(modal);
//                    return;
//                }
                    

//                const items = modal.querySelectorAll('.modal-body .carousel .carousel-item');
//                if (!items || items.length === 0) {
//                    displayCarousel(modal);
//                    return;
//                }

//                for (let i = 0; i < items.length; i++) {
//                    const item = items[i];
//                    if (parseInt(item.getAttribute('data-imageid')) !== imageId)
//                        continue;

//                    carousel.to(i);
//                    displayCarousel(modal);
//                    break;
//                }
//            });
//        });
//    };
    
//    elements.forEach(element => { init(element); });
//}